/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrderRequest
 */
export interface CreateOrderRequest {
    /**
     * ID of the credit package to purchase
     * @type {string}
     * @memberof CreateOrderRequest
     */
    packageId: string;
    /**
     * Payment method to use (stripe for web, iap for mobile)
     * @type {string}
     * @memberof CreateOrderRequest
     */
    paymentMethod: CreateOrderRequestPaymentMethodEnum;
}


/**
 * @export
 */
export const CreateOrderRequestPaymentMethodEnum = {
    Stripe: 'stripe',
    Iap: 'iap'
} as const;
export type CreateOrderRequestPaymentMethodEnum = typeof CreateOrderRequestPaymentMethodEnum[keyof typeof CreateOrderRequestPaymentMethodEnum];


/**
 * Check if a given object implements the CreateOrderRequest interface.
 */
export function instanceOfCreateOrderRequest(value: object): value is CreateOrderRequest {
    if (!('packageId' in value) || value['packageId'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    return true;
}

export function CreateOrderRequestFromJSON(json: any): CreateOrderRequest {
    return CreateOrderRequestFromJSONTyped(json, false);
}

export function CreateOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'packageId': json['packageId'],
        'paymentMethod': json['paymentMethod'],
    };
}

  export function CreateOrderRequestToJSON(json: any): CreateOrderRequest {
      return CreateOrderRequestToJSONTyped(json, false);
  }

  export function CreateOrderRequestToJSONTyped(value?: CreateOrderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'packageId': value['packageId'],
        'paymentMethod': value['paymentMethod'],
    };
}

